import api from '../services/api';

// Check if user is logged in
export const isLoggedIn = () => {
  const token = localStorage.getItem('token');
  return !!token;
};

// Check if user is admin
export const isAdmin = () => {
  const user = localStorage.getItem('user');
  if (!user) return false;
  
  try {
    const userData = JSON.parse(user);
    
    // Check if user has admin role
    if (userData.roles && Array.isArray(userData.roles)) {
      return userData.roles.includes('admin');
    }
    
    // Alternative check if role is stored directly
    if (userData.role) {
      return userData.role === 'admin';
    }
    
    return false;
  } catch (error) {
    console.error('Error parsing user data:', error);
    return false;
  }
};

// Function to log in as admin for testing
export const loginAsAdmin = async () => {
  try {
    console.log('Attempting to log in as admin...');
    // According to the API configuration, we need to use the full path
    const response = await api.post('/api/v1/auth/login', {
      email: 'admin@example.com',
      password: 'password'
    });
    
    console.log('Login response:', response.data);
    
    if (response.data.success && response.data.data && response.data.data.token) {
      localStorage.setItem('token', response.data.data.token);
      localStorage.setItem('user', JSON.stringify({
        ...response.data.data.user,
        role: 'admin' // Ensure the user has admin role
      }));
      console.log('Successfully logged in as admin');
      return true;
    } else if (response.data.token) {
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('user', JSON.stringify({
        ...response.data.user,
        role: 'admin' // Ensure the user has admin role
      }));
      console.log('Successfully logged in as admin');
      return true;
    } else {
      console.error('No token received from login');
      return false;
    }
  } catch (error) {
    console.error('Login error:', error);
    return false;
  }
};

// Ensure admin is logged in before making API requests
export const ensureAdminLogin = async () => {
  try {
    // Check if already logged in as admin
    if (isLoggedIn() && isAdmin()) {
      console.log('Already logged in as admin');
      return true;
    }
    
    // If not, attempt to log in
    console.log('Not logged in as admin, attempting login...');
    return await loginAsAdmin();
  } catch (error) {
    console.error('Error ensuring admin login:', error);
    return false;
  }
};

// Logout function
export const logout = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  console.log('Logged out successfully');
};

export default {
  isLoggedIn,
  isAdmin,
  loginAsAdmin,
  ensureAdminLogin,
  logout
};
